import * as React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import * as Theme from '../../../serviceTheme';
import { GLOBAL_INPUT_CLASS } from '../../../core/Input';

import { useControl, Model, withValidator, ValidRules } from '..';
import { Input, INPUT_HEIGHT } from '../shared';

declare module '../../Controls/hkt' {
    interface URIControlsToKind {
        'valid': IValidProps
    }
}


type IValidProps = {
    name: string,
    value?: string,
    onChange: (name: string, isValid: boolean, value: string) => void,
    placeholder?: string,
    disabled?: boolean,
    className?: string,
}

const model: Model<string> = {
    empty: '',
    putIn: (x) => x,
    putOut: (x) => x,
}

const validationRules: ValidRules<string> = [
    [x => x.length > 4, 'Символов должно быть больше 4'],
    [x => /[0-9]/g.test(x), 'Должна быть хоть одна цифра'],
    [x => /[A-Z]/g.test(x), 'Должна быть хотя бы одна заглавная буква'],
    [x => /[a-z]/g.test(x), 'Должна быть хотя бы одна маленькая буква'],
];

export const ErrorMessage = styled.p`
    background-color: ${Theme.safeGetPrimary};
    color: #fff;
    padding: 2px 7px;
    margin-top: 8px;
    bottom: 0;
    display: inline-block;
`;

const Wrapper = styled.div`
    width: 100%;
`;

const getValid = ({ isWarn, theme }: { isWarn: boolean, theme: DefaultTheme }) => isWarn 
    ? { borderColor: Theme.safeGetPrimary({ theme })}
    : { borderColor: undefined };

const ValidInput = styled(Input)<{ isWarn: boolean }>`
    width: 100%;
    ${getValid};
`;

const Valid = React.forwardRef<HTMLInputElement, IValidProps>(({ 
    name,
    value = '', 
    onChange, 
    placeholder = '', 
    disabled = false,
    className,
}, ref) => {
    const { 
        value: localValue, 
        displayValue, 
        isValid,
        inoutput,
        validate,
        resetValid,
        isIndetermination,
        errMessage,
    } = withValidator(useControl, validationRules)(model, value);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const s = e.target.value;
        inoutput(s);
    }

    const handleFocus = () => {
        resetValid();
    }

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const s = e.target.value;
        validate(s);
    }

    React.useEffect(() => {
        onChange(name, isValid(), localValue);
    }, [localValue]);

    const renderErrorMessage = !isValid() && !isIndetermination();

    return (
        <Wrapper className="wrapper-valid">
            <WrapperInput className="wrapper-input">
                <ValidInput
                    ref={ref}
                    className={[GLOBAL_INPUT_CLASS, className].join(' ')}
                    name={name}
                    value={displayValue}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    disabled ={disabled}
                    isWarn={renderErrorMessage}
                />
            </WrapperInput>
            <WrapperMessage className="wrapper-message">
                {renderErrorMessage && <ErrorMessage className="error-message">{errMessage}</ErrorMessage>}
            </WrapperMessage>
        </Wrapper>
    );
});

const WrapperInput = styled.div`
    min-height: ${INPUT_HEIGHT};
    display: flex;
`;

const WrapperMessage = styled.div``;

export default Valid;
